import { SET_ACCESS_TOKEN, SET_PROFILE_PIC_ACCESS_TOKEN } from 'redux/reduxConstants';

const initialState = {
	accessToken: '',
	accessTokenExpiresOn: new Date(),
	profilePicAccessToken: null,
	profilePicAccessTokenExpiresOn: new Date(),
};

const auth = (state = initialState, action: any) => {
	switch (action.type) {
		case SET_ACCESS_TOKEN:
			let accessTokenState = { ...state };

			accessTokenState.accessToken = action.access_token;
			accessTokenState.accessTokenExpiresOn = action.expiresOn;
			return accessTokenState;

		case SET_PROFILE_PIC_ACCESS_TOKEN:
			let profilePicAccessTokenState = { ...state };

			profilePicAccessTokenState.profilePicAccessToken = action.access_token;
			profilePicAccessTokenState.profilePicAccessTokenExpiresOn = action.expiresOn;
			return profilePicAccessTokenState;
		default:
			return state;
	}
};

export default auth;
